<div class="PageContent">

    <div class="overlayTransparent animated fadeIn" *ngIf="this.InternalTasks?.length > 0 || ShowFilter == true;" (click)="CloseOverlay();"></div>
    <div class="overlay animated fadeIn" *ngIf="ShowDeleteTaskContainer" (click)="CloseDashMenu();" style="z-index: 202;" (click)="ShowDeleteTaskContainer = false;"></div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteTaskContainer">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteTaskContainer = false; CurrentTask = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteTaskContainer = false; CurrentTask = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteTaskContainer = false; DeleteInternalTask();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="PageContentTitle">
        <div class="PageContentTitleIntro">
            <i class="material-icons">work_outline</i>
            <i class="material-icons">schedule</i>
            <p class="PageContentTitleParagraph">{{'Tasks' | translate}}</p>
        </div>

        <div class="TitleSearchInputContainer">
            <input type="text" (click)="SearchInternalTasks(this.SearchTerm);" class="TitleSearchInput" placeholder="{{'SearchTasks' | translate}}" autocomplete="off" [(ngModel)]="this.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
            <i class="material-icons TitleSearchInputContainerSearchIcon">search</i>
            <i class="material-icons TitleSearchInputContainerCloseIcon" *ngIf="this.SearchTerm?.length > 0;" (click)="this.SearchTerm = ''; this.InternalTasks.length = 0;">close</i>

            <div class="TitleSearchInputResultsContainer" *ngIf="this.InternalTasks?.length > 0;">
                <div class="TitleSearchInputResult" *ngFor="let task of this.InternalTasks; let i=index;" (click)="ViewTask(task);">
                    <div class="TitleSearchInputResultTitle">
                        <p class="TitleSearchRightInfo">
                            {{task.Title}}
                        </p>
                        <p class="TitleSearchRightInfo">
                           <span class="AssigneeBox" *ngFor="let a of task.Assignees;">{{a.UIName}} <span *ngIf="task.Owner.Id == a.Id;">[{{'Owner' | translate}}]</span></span>
                        </p>
                    </div>
                    <div class="TitleSearchInputResultDate">
                        <p class="TitleSearchRightInfo">
                            {{task.MaxExpectedResolveDateUI}}
                        </p>
                        <p class="TitleSearchRightInfo">
                            <span class="TitleSearchRightInfoBox" [ngClass]="{'ToDoStatus': task.Status.ID == -1, 'InProgressStatus': task.Status.ID == 0,'CompletedStatus': task.Status.ID == 1 }">{{task.Status.Name}}</span>
                            <span class="TitleSearchRightInfoBox" [ngClass]="{'StandardStatus': task.Severity.ID == 0, 'UrgentStatus': task.Severity.ID == 1,'CriticalStatus': task.Severity.ID == 2 }">{{task.Severity.Name}}</span>
                        </p>
                    </div>
                </div>        
            </div>
        </div>

        <div class="PageContentTitleCommands">
            <button mat-raised-button color="primary" class="TitleFilterButton" (click)="GetAllInternalTasksCreators();GetAllInternalTasksAssignees();ShowFilter = !ShowFilter;">
                {{'Filter' | translate}}
                <i class="material-icons">filter_alt</i>
                <span class="ButtonNotification" *ngIf="activeFilters.length > 0;">{{activeFilters.length}}</span>
            </button>

            <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="this.parent.RedirectToURLWithUrlChange('/management/newtask');">
                {{'NewTask' | translate}}
                <i class="material-icons">add</i>
            </button>

            <div class="ButtonFilterContainer animated fadeIn" *ngIf="ShowFilter == true;">
                <i class="material-icons ButtonFilterContainerCloseIcon" (click)="ShowFilter = false;">close</i>
                <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.FilterLoading == true;"></mat-spinner>
                
                <div *ngIf="this.FilterLoading != true;">
                    <div class="ButtonFilterContainerRow">
                        <div class="ButtonFilterContainerOneThirdColumn">
                          <mat-form-field class="ButtonFilterDropDown" appearance="outline">
                            <mat-label>{{'Company' | translate}}</mat-label>
                            <mat-select name="Company" [(ngModel)]="Filter.Company">
                              <mat-option *ngFor="let c of this.Companies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Company');">
                                {{c.Name}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="ButtonFilterContainerTwoThirdsColumn">
                            <mat-form-field class="ButtonFilterDropDown" appearance="outline">
                                <mat-label>{{'Creator' | translate}}/{{'Owner' | translate}}</mat-label>
                                <mat-select name="Company" [(ngModel)]="Filter.Creator">
                                  <mat-option *ngFor="let c of this.Creators;" [value]="c" (click)="AddActiveFilter(c.UIName, 'Creator');">
                                    {{c.UIName}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                        </div>
                    </div>

                    <div class="ButtonFilterContainerRow">
                        <div class="ButtonFilterContainerOneThirdColumn">
                          <mat-form-field class="ButtonFilterDropDown" appearance="outline">
                            <mat-label>{{'TaskSeverity' | translate}}</mat-label>
                            <mat-select name="Severity" [(ngModel)]="Filter.Severity">
                              <mat-option *ngFor="let s of this.SeverityTypes;" [value]="s" (click)="AddActiveFilter(s.Name, 'TaskSeverity');">
                                {{s.Name}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="ButtonFilterContainerTwoThirdsColumn">
                            <mat-form-field class="ButtonFilterDropDown" appearance="outline">
                                <mat-label>{{'Status' | translate}}</mat-label>
                                <mat-select name="TaskStatus" [(ngModel)]="Filter.TaskStatus">
                                  <mat-option *ngFor="let s of this.InternalTaskStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'Status');">
                                    {{s.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                        </div>
                    </div>

                    <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerOneThirdColumn">
                       
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline">
                          <mat-label>{{'Assignee' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.Assignee">
                            <mat-option *ngFor="let c of this.Assignees;" [value]="c" (click)="AddActiveFilter(c.UIName, 'Assignee');">
                              {{c.UIName}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                  </div>

                    <div class="ButtonFilterContainerRow" style="padding-left: 3%;height: auto;min-height: 60px;padding-top: 10px;">
                      <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
                        {{a.Name}}
                        <i class="material-icons ActiveFilterIcon">close</i>
                      </div>
                    </div>

                    <div class="ButtonFilterContainerRow" style="margin-bottom: 15px;">
                        <div class="ButtonFilterContainerOneThirdColumn">
                            <button mat-raised-button color="primary" class="ApplyFilterButton" (click)="ShowFilter = false;GetInternalTasksFiltered();">
                                <i class="material-icons">check</i>
                                {{'ApplyFilter' | translate}}
                            </button>
                        </div>
                        <div class="ButtonFilterContainerTwoThirdsColumn">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

      <div class="PageContentBody animated fadeIn">
        <div class="PageContentBodyTopCommands">
            <mat-form-field class="TopCommandDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
                <mat-select name="Administration" [(ngModel)]="Filter.Period">
                  <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetInternalTasksFiltered();">
                    {{a.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            
              <mat-form-field class="TopCommandDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
              </mat-form-field>
            
              <mat-form-field class="TopCommandDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                <mat-datepicker #dp1></mat-datepicker>
              </mat-form-field>

              <div class="TopLevelPaginator unSelectable">
                <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetInternalTasksFiltered(this.Filter.Pager.PageIndex - 1);">
                  <i class="material-icons">chevron_left</i>
                </div>
                <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                  <i class="material-icons">chevron_left</i>
                </div>

                <mat-form-field appearance="outline" class="TopLevelPaginatorTextBox">
                  <mat-label>{{ 'PageSize' | translate }}*</mat-label>
                  <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetInternalTasksFiltered(1);">
                </mat-form-field>

                <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetInternalTasksFiltered(this.Filter.Pager.PageIndex + 1);">
                  <i class="material-icons">chevron_right</i>
                </div>
                <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                  <i class="material-icons">chevron_right</i>
                </div>

                <span class="pageInfoSpan">{{this.Tasks?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Tasks' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
              </div>

              <button mat-raised-button color="primary" class="FilterResultsButton" (click)="GetInternalTasksFiltered();">
                <i class="material-icons">check</i>
                {{'ApplyFilter' | translate}}
            </button>
        </div>

        <div class="PageContentBodyElementsContainer">
          <div class="TaskRow TaskHeadderRow">
            <div class="TaskCol dottedRow" style="width: 5%;text-align:center;">
              #
            </div>
            <div class="TaskCol" style="width: 15%;">
              {{'Title' | translate}}
            </div>
            <div class="TaskCol" style="width: 15%;">
              {{'Asignees' | translate}}
            </div>
            <div class="TaskCol" style="width: 10%;">
              {{'Company' | translate}}
            </div>
            <div class="TaskCol" style="width: 7.5%;">
              Status
            </div>
            <div class="TaskCol" style="width: 7.5%;">
              {{'TaskSeverity' | translate}}
            </div>
            <div class="TaskCol" style="width: 10%;">
              {{'Owner' | translate}}
            </div>
            <div class="TaskCol" style="width: 10%;">
              {{'EventRegister' | translate}}
            </div>
            <div class="TaskCol" style="width: 10%;">
              {{'MaxExpectedResolveDate' | translate}}
            </div>
            <div class="TaskCol" style="width: 10%;text-align:center;">
              {{'Actions' | translate}}
            </div>
          </div>
          <div class="TaskRow" *ngFor="let task of this.Tasks; let i=index;">
            <div class="TaskCol" style="width: 5%;text-align:center;">
              <i class="material-icons countCircle">circle</i>
              <span class="countSpan">{{i + 1}}</span>
            </div>
            <div class="TaskCol" style="width: 15%;">
              {{task.Title}}
            </div>
            <div class="TaskCol" style="width: 15%;">
              {{task.AssigneesRow}}
            </div>
            <div class="TaskCol" style="width: 10%;">
              {{task.Company.Name}}
            </div>
            <div class="TaskCol" style="width: 7.5%;">
              <span class="TaskStatusSpan" [ngClass]="{'ToDoStatus': task.Status.ID == -1, 'InProgressStatus': task.Status.ID == 0,'CompletedStatus': task.Status.ID == 1 }">{{task.Status.Name}}</span>
            </div>
            <div class="TaskCol" style="width: 7.5%;">
              <span class="TaskStatusSpan" [ngClass]="{'StandardStatus': task.Severity.ID == 0, 'UrgentStatus': task.Severity.ID == 1,'CriticalStatus': task.Severity.ID == 2 }">{{task.Severity.Name}}</span>
            </div>
            <div class="TaskCol" style="width: 10%;">
              {{task.Owner.UIName}}
            </div>
            <div class="TaskCol" style="width: 10%;">
              {{task.EventRegisterUI}}
            </div>
            <div class="TaskCol" style="width: 10%;">
              {{task.MaxExpectedResolveDateUI}}
            </div>
            <div class="TaskCol" style="width: 10%;text-align:center;">
              <i class="material-icons actionsArrow unSelectable" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
              <mat-menu #menu="matMenu">
               <button mat-menu-item class="ReceptionMenuButton" (click)="ViewTask(task);">
                   <i class="material-icons">image_search</i>
                   <span>{{ 'Receptions.Table.ButtonMenu.Visualize' | translate }} / {{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
               </button>
               <button mat-menu-item class="ReceptionMenuButton" (click)="this.CurrentTask = task;this.ShowDeleteTaskContainer = true;">
                 <i class="material-icons">close</i>
                 <span>{{ 'Delete' | translate }}</span>
               </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
     
  </div>